import styled from "styled-components";

export const StyledMenu = styled.ul`
  list-style-type: none;
  padding: 0;
  > li {
  }
`;
